<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs4 pa-2>
                                <v-card flat>
                                    <v-layout row>
                                        <div style="width:320px; margin-left:10px;">
                                            <v-img  :src="require('@/assets/img/hk.png')" max-height="156">
                                                <v-layout pa-2 column fill-height class="white--text">
                                                    <v-spacer></v-spacer>
                                                    <v-flex>
                                                        <div class="headline" style="font-size: 60px !important;"><strong>MTR - {{facilityName}}</strong></div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-img>
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div style="width:245px;">
                                            <value-box :value="totalSensors" use-int
                                                       title="POINTS MONITORED"
                                            >
                                            </value-box>
                                            <value-box :value="totalRules" use-int
                                                       title="ANALYTICS RULES"
                                            >
                                            </value-box>
                                        </div>

                                    </v-layout>

                                </v-card>
                            </v-flex>
                            <v-flex xs8 pa-2>
                                <v-card flat>
                                    <v-img :src="require('@/assets/img/eoimage.jpg')" max-height="156">
                                    </v-img>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs4 pa-2>
                                <v-card flat>
                                    <v-card-title class="primary white--text headline">
                                        Comfort Performance
                                        <v-spacer></v-spacer>
                                        <span class="mr-2">Change - </span>
                                        <span class="green-thing green-icon">2% YOY
                                            <v-icon>fa-long-arrow-alt-up</v-icon>
                                        </span>
                                    </v-card-title>
                                    <v-layout row>
                                    <div style="width:320px; margin-left:10px;">
                                        <v-gauge :value="oci" :maxValue="1" :minValue="-1" height="156"
                                                 width="320" :options="gaugeOptions" gaugeValueClass="hidden"></v-gauge>
                                        <div class="gaugepos1">{{oci.toFixed(2)}}</div>
                                    </div>
                                        <v-spacer></v-spacer>
                                        <div>
                                            <value-box :value="oci" unit="" title="Mean PMV" style="width:244px"
                                                       explanation
                                            >
                                                <p>
                                                    A PMV of 0 indicates neutral temperature while negative value indicates cooler conditions and positive value indicates warmer conditions.
                                                    The calculation assumes a low air velocity of 0.1 m/s, a relative humidity of 70%, seated and clothing level of jacket and long-sleeved shirts.
                                                </p>
                                                <p>
                                                    References:
                                                </p>
                                                <ul>
                                                    <li><a class="white--text" target="_blank" href="https://comfort.cbe.berkeley.edu/">Thermal Comfort Tool - Center for the Built Environment Berkeley</a></li>
                                                </ul>
                                            </value-box>
                                            <value-box :value="irp" unit="°C" title="Mean Temperature"

                                            >

                                            </value-box>
                                        </div>

                                    </v-layout>
                                    <vue-plotly disable-responsive :data="ahuRangeData" :layout="ahuRangeLayout"
                                                :options="{}"/>
                                </v-card>
                            </v-flex>
                            <v-flex xs4 pa-2>
                                <v-card flat height="100%">
                                    <v-card-title class="primary white--text headline">
                                        Fault Detection
                                    </v-card-title>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <value-box
                                                    :value="totalFault"
                                                    icon=""
                                                    use-int
                                                    :title="' Total Faults'">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box
                                                    :value="unackFault"
                                                    icon=""
                                                    use-int
                                                    :title="' Total Unack Faults'">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box
                                                    :value="ackFault"
                                                    icon=""
                                                    use-int
                                                    :title="' Total Ack Faults'">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box
                                                    :value="fddCost"
                                                    icon=""
                                                    use-int
                                                    unit="HKD"
                                                    :title="' FDD Costs'">
                                            </value-box>
                                        </v-flex>

                                        <v-flex xs12>
                                            <vue-plotly disable-responsive v-if="fddData" :data="fddData" :layout="fddLayout" :options="{}"/>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                            <v-flex xs4 pa-2>
                                <v-card flat height="100%">
                                    <v-card-title class="primary white--text headline">
                                        Energy Performance
                                        <v-spacer></v-spacer>
                                        <!-- span class="mr-2">Change - </span>
                                        <span class="green-thing green-icon">3% YOY
                                            <v-icon>fa-long-arrow-alt-up</v-icon>
                                        </span -->
                                    </v-card-title>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <value-box has-comma :value="totalSavingSum" unit="kWh" title="Saving after optimisation" ></value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box :value="savingPercentage" unit="%" title="Saving"  class="green-icon"></value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box has-comma :value="totalSavingSum*0.51" unit="kgCO2e" title="Carbon Emissions Saved" ></value-box>
                                        </v-flex>
                                        <v-flex xs6>
                                            <value-box has-comma :value="totalSavingSum*1.2" unit="HKD" title="HKD Savings"></value-box>
                                        </v-flex>
                                        <v-flex xs12>
                                            <vue-plotly :data="data" :layout="layout" :options="{}" ref="plotly"/>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>

    import moment from 'moment'
    import {callAPI,getNotification,getIssueSummary,getRule} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";
    import VGauge from 'vgauge';
    import ValueBox from "../components/ValueBox";
    import { mapGetters } from 'vuex'


    export default {
        name: 'MTRExecutiveOverview',
        components: {VuePlotly,DateRangeSelector,VGauge,ValueBox},
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(8, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(8, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                tempRange:[21.3,24.7], //From ASHRAE-55 tc with 70% humidity,  m rate and 0.96 clo
                ahus:[],
                paus:[],
                oci:null,
                totalPowerSum:null,
                totalSavingSum:null,
                data:null,
                fddData:null,
                totalFault:null,
                forcedBlue:[
                    "2019-08-27 00:00:00", "2019-08-28 00:00:00", "2019-08-29 00:00:00", "2019-08-30 00:00:00",
                    "2019-08-31 00:00:00", "2019-09-01 00:00:00", "2019-09-02 00:00:00", "2019-09-03 00:00:00",
                    "2019-10-29 00:00:00", "2019-10-31 00:00:00", "2019-11-05 00:00:00", "2019-11-07 00:00:00",
                    "2019-11-12 00:00:00", "2019-11-14 00:00:00", "2019-11-19 00:00:00", "2019-11-20 00:00:00",
                    "2019-12-24 00:00:00", "2019-12-25 00:00:00", "2020-01-03 00:00:00", "2020-01-07 00:00:00",
                    "2020-01-09 00:00:00", "2020-01-14 00:00:00", "2020-01-16 00:00:00", "2020-01-21 00:00:00",
                    "2020-01-23 00:00:00", "2020-01-28 00:00:00", "2020-01-30 00:00:00", "2020-02-04 00:00:00",
                    "2020-02-06 00:00:00", "2020-02-18 00:00:00", "2020-02-20 00:00:00", "2020-02-25 00:00:00",
                    "2020-02-27 00:00:00", "2020-03-03 00:00:00", "2020-03-05 00:00:00", "2020-03-12 00:00:00",
                    "2020-03-17 00:00:00", "2020-03-19 00:00:00",
                ],
                unackFault:null,
                ackFault:null,
                fddCost:null,
                pastPower:null,
                totalRules:null,
                totalSensors:null,
                currentPower:null,
                pastRange:null,
                bpi:null,
                powerDiff:null,
                energyData:null,
                energyHeatmapData:null,
                layout:{
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range:[15,35]
                    },
                    yaxis: {
                        title: 'Total energy consumption (kWh)',
                        rangemode:'tozero',
                        range:[0,6000],
                    },
                    shapes: [

                    ],
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: -0.2
                    },
                    height:460,
                    margin: {
                        l: 60,
                        r: 30,
                        b: 30,
                        t: 100,
                        pad: 1
                    },

                },
                // energyLayout:{
                //     title:"Energy Consumption VS Baseline",
                //     legend: {
                //         orientation: 'h',
                //         x: 0,
                //         y: -0.2
                //     },
                //     height:460,
                //     margin: {
                //         l: 60,
                //         r: 30,
                //         b: 30,
                //         t: 100,
                //         pad: 1
                //     },
                //     yaxis: {
                //         title: 'Energy (kWh)',
                //         showgrid:false
                //     },
                //     xaxis: {
                //         title: 'Time (Hourly)',
                //         showgrid:false
                //     }
                // },
                irp:null,
                ahuRangeData: null,
                ahuRangeLayout: {
                    title: "Indoor Temperature (°C)",
                    showlegend:false,
                    xaxis:{
                        showgrid:false
                    },
                    yaxis:{
                        showgrid:false,
                        range:[21,27],
                    },
                    height:460,
                    margin: {
                        l: 60,
                        r: 30,
                        b: 30,
                        t: 100,
                        pad: 1
                    },
                },
                fddLayout: {
                    title: "Unack Faults per Equipment Type",
                    showlegend:false,
                    xaxis:{
                        showgrid:false
                    },
                    yaxis:{
                        showgrid:false
                    },
                    height:460,
                    margin: {
                        l: 60,
                        r: 30,
                        b: 30,
                        t: 100,
                        pad: 1
                    },
                },

            }
        },
        computed:{
            // ...mapGetters([
            //     'facilityFloorArea',
            //     'factors'
            // ]),
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            facilityFloorArea(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="ES"){
                    return 141308
                } else if (this.$store.state.pointsListStore.pointsList.facility_name==="CH") {
                    return 43014
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="PB") {
                    return 52500
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="AX") {
                    return 45163
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="JH") {
                    return 86700
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="LM") {
                    return 151182
                } else {
                    return 141308
                }
            },
            factors(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="ES"){
                    return [2.2343,3.868]
                } else if (this.$store.state.pointsListStore.pointsList.facility_name==="CH") {
                    return [2.1944,4.1037]
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="PB") {
                    return [1.4092,8.5551]
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="AX") {
                    return [1.8697,4.9973]
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="JH") {
                    return [1.4126,8.5952]
                }else if (this.$store.state.pointsListStore.pointsList.facility_name==="LM") {
                    return [2.9137,18.761]
                } else {
                    return [2.2343,3.868]
                }
            },
            facilityName(){
                return this.$store.state.pointsListStore.pointsList.facility_name;
            },
            energyHeatmapLayout(){
                return {
                    title:"Power Heat Map",
                    yaxis: {
                        autotick: false,
                    }
                }
            },
            gaugeOptions(){
                    return {
                        angle: 0,
                        lineWidth: 0.04,
                        radiusScale: 1,
                        pointer: {
                            length: 0.5,
                            strokeWidth: 0.020,
                            color: '#606060'
                        },
                        limitMax: false,
                        limitMin: false,
                        highDpiSupport: true,
                        staticZones: [
                            {strokeStyle: "#FB1E00", min: -1, max: -0.5},
                            {strokeStyle: "#00CF27", min: -0.5, max: 0.5},
                            {strokeStyle: "#FB1E00", min: 0.5, max: 1},
                        ],
                        staticLabels: {
                            font: "14px sans-serif",  // Specifies font
                            labels: [-1,-0.5,0.5,1],  // Print labels at these values
                            color: "#FFFFFF",  // Optional: Label text color
                            fractionDigits: 2  // Optional: Numerical precision. 0=round off.
                        }
                    }
            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            polyCurb(x){
                return(-0.21678982325554988*x*x*x*x + 20.499523198081228*x*x*x - 692.2944568911432*x*x + 10022.552049287606*x -52185.12514693242)
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let pastRange=[moment(currentRange[0]).subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment(currentRange[1]).subtract(1, "week").endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                me.pastRange={start:moment(currentRange[0]).subtract(1, "week").startOf('day').format('YYYY-MM-DD'),end:moment(currentRange[1]).subtract(1, "week").endOf('day').format('YYYY-MM-DD')}
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type==="ECFAN"||equip.equipment_type==="ahu"){
                        me.ahus.push(equip.equipment_name)
                    } else if(equip.equipment_type==="PAU"){
                        me.paus.push(equip.equipment_name)
                    }
                }
                if(me.ahus.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type_regex': 'ecfan|ahu',
                                'sensor_names': [ 'IndoorTemp','Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.SUPPLY AIR TEMP'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (ahuRes) {
                        let ahuNames = []
                        let ahuTemps = []
                        let ahta=[]
                        let ahts=[]
                        for (let ahuName of me.ahus) {
                            if (ahuRes.data[ahuName + ' - IndoorTemp']) {
                                let ahuTempArray = []
                                let ahuTempTS = []
                                for (let flowindex in ahuRes.data[ahuName + ' - '+'Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.SUPPLY AIR TEMP']) {
                                    let flow = ahuRes.data[ahuName + ' - '+'Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.SUPPLY AIR TEMP'][flowindex]
                                    if ((flow >0)) {
                                        if (ahuRes.data[ahuName + ' - IndoorTemp']) {
                                            ahuTempArray.push(ahuRes.data[ahuName + ' - IndoorTemp'][flowindex])
                                            ahuTempTS.push(ahuRes.data.timestamp[flowindex])
                                        }
                                    }
                                }
                                ahta=ahuTempArray
                                ahts=ahuTempTS
                                let temp = ahuTempArray.reduce((p, c) => p + c, 0) / ahuTempArray.length
                                if (temp > 0 && temp < 40) {
                                    ahuTemps.push(temp)
                                    ahuNames.push(ahuName)
                                }
                            }
                        }
                        callAPI('thermalcomfort/',
                            {
                                "tdb":ahuTemps
                            }
                        ).then(function(tc){
                            me.oci=tc.data.result.pmv[0]
                        })
                        // let timestamp=ahuRes.data.timestamp
                        // let inRangePercentage=[]
                        // for (let index in timestamp){
                        //     let total=0
                        //     let inRange=0
                        //     for (let ahuName of me.ahus) {
                        //             let flow = ahuRes.data[ahuName + ' - '+'Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.SUPPLY AIR TEMP'][index]
                        //             if (flow >0) {
                        //                 total+=1;
                        //                 if (me.tempRange[0]<=ahuRes.data[ahuName + ' - IndoorTemp'][index]&&ahuRes.data[ahuName + ' - IndoorTemp'][index]<=me.tempRange[1]) {
                        //                     inRange+=1
                        //                 }
                        //             }
                        //     }
                        //     let percentageWithin=total>0 ? inRange*100/total : 0
                        //     inRangePercentage.push(Math.round(percentageWithin * 100) / 100)
                        // }
                        me.ahuRangeData=[
                            {x:ahts,y:ahta,fill: 'tozeroy',fillcolor:"rgba(44, 160, 44, 0.5)",mode:"lines",line:{color:"rgba(44, 160, 44, 0.5)"}},
                        ]
                        me.irp=ahuTemps[0]

                    })
                } else if (me.paus.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type': 'PAU',
                                'sensor_names': ['on', 'CD_TEM'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (ahuRes) {
                        let ahuNames = []
                        let ahuTemps = []
                        for (let ahuName of me.paus) {
                            if (ahuRes.data[ahuName + ' - on']) {
                                let ahuTempArray = []
                                for (let flowindex in ahuRes.data[ahuName + ' - on']) {
                                    let flow = ahuRes.data[ahuName + ' - on'][flowindex]
                                    if (flow > 0) {
                                        if (ahuRes.data[ahuName + ' - CD_TEM']) {
                                            ahuTempArray.push(ahuRes.data[ahuName + ' - CD_TEM'][flowindex])
                                        }
                                    }
                                }
                                let temp = ahuTempArray.reduce((p, c) => p + c, 0) / ahuTempArray.length
                                if (temp > 0 && temp < 40) {
                                    ahuTemps.push(temp)
                                    ahuNames.push(ahuName)
                                }
                            }
                        }
                        callAPI('thermalcomfort/',
                            {
                                "tdb": ahuTemps
                            }
                        ).then(function (tc) {
                            me.oci = 100 * tc.data.result.pmv.filter(x => x <= 0.5 && x >= -0.5).length / tc.data.result.pmv.length
                            me.loading = false
                        })
                        let timestamp = ahuRes.data.timestamp
                        let inRangePercentage = []
                        for (let index in timestamp) {
                            let total = 0
                            let inRange = 0
                            for (let ahuName of me.ahus) {
                                if (ahuRes.data[ahuName + ' - CD_TEM'] && (ahuRes.data[ahuName + ' - on'] || ahuRes.data[ahuName + ' - INVERT'])) {
                                    let onOrInvert = ahuRes.data[ahuName + ' - on'] ? 'on' : 'INVERT'
                                    let flow = ahuRes.data[ahuName + ' - ' + onOrInvert][index]
                                    if ((flow >= 20 && onOrInvert == 'INVERT') || (flow > 0 && onOrInvert == 'on')) {
                                        total += 1;
                                        if (me.tempRange[0] <= ahuRes.data[ahuName + ' - CD_TEM'][index] && ahuRes.data[ahuName + ' - CD_TEM'][index] <= me.tempRange[1]) {
                                            inRange += 1
                                        }
                                    }
                                }
                            }
                            let percentageWithin = total > 0 ? inRange * 100 / total : 0
                            inRangePercentage.push(Math.round(percentageWithin * 100) / 100)
                        }
                        me.ahuRangeData = [
                            {
                                x: timestamp,
                                y: inRangePercentage,
                                fill: 'tozeroy',
                                fillcolor: "rgba(44, 160, 44, 0.5)",
                                mode: "lines",
                                line: {color: "rgba(44, 160, 44, 0.5)"}
                            },
                        ]
                        me.irp = inRangePercentage.reduce((p, c) => p + c, 0) / inRangePercentage.length


                    })
                }
                let rangeStart = _.get(this.$route.query,'rangeStart', null)
                if(!rangeStart){
                    rangeStart=this.$store.state.pointsListStore.pointsList.facility_name=="SHT" ? "2019-08-27" : "2019-10-17"
                }
                let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
                let promises=[];
                let timestamp=null;
                let totalPower=null;
                let avgTemp=null;
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type==='chiller'){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[rangeStart, rangeEnd+" 23:59"],
                                'sensor_names': ['Comp_Power']
                            }
                        ))
                    } else if(equip.equipment_type==='pump'){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[rangeStart, rangeEnd+" 23:59"],
                                'sensor_names': ['KW']
                            }
                        ))
                    }
                }

                promises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': 'Weather',
                        'agg': 'D',
                        'agg_op': 'mean',
                        'date_range':[rangeStart, rangeEnd+" 23:59"],
                        'sensor_names': ['Outdoor_Temperature']
                    }
                ))


                Promise.all(promises).then(function(reses) {
                    for (let res of reses){
                        if(!timestamp){
                            timestamp=res.data.timestamp;
                        }
                        if(res.data['Outdoor_Temperature']){
                            avgTemp=res.data['Outdoor_Temperature'];
                        } else {
                            if(!totalPower){
                                if(res.data['Comp_Power']){
                                    totalPower=res.data['Comp_Power'];
                                } else if (res.data['KW']){
                                    totalPower=res.data['KW'];
                                }
                            } else {
                                if(res.data['Comp_Power']){
                                    totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                                } else if (res.data['KW']){
                                    totalPower=me.addArrays(totalPower,res.data['KW'])
                                }
                            }
                        }

                    }
                    let preAvgTemp=[];
                    let postAvgTemp=[];
                    let preTotalPower=[];
                    let postTotalPower=[];
                    let preLabels=[];
                    let postLabels=[];
                    let totalPowerSum=0;
                    let totalSavingSum=0;
                    let polyCurbTemp=[];
                    let polyCurbPower=[];
                    for (let i=15; i<=32;i+=0.5){
                        polyCurbTemp.push(i);
                        polyCurbPower.push(me.polyCurb(i))
                    }
                    for (let k in timestamp){
                        if(me.forcedBlue.includes(timestamp[k])){
                            preAvgTemp.push(avgTemp[k]);
                            preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                            preLabels.push(timestamp[k].substring(0, 10));
                        } else {
                            postAvgTemp.push(avgTemp[k]);
                            postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                            postLabels.push(timestamp[k].substring(0, 10));
                        }
                    }


                    // let trendBeforeCurb=findLineByLeastSquares(preAvgTemp,preTotalPower)
                    // let getY=function(x,trend){
                    //     return ((x*trend[0])+trend[1])
                    // }
                    // let trendBefore=[[15,35],[getY(15,trendBeforeCurb),getY(35,trendBeforeCurb)]]
                    for (let k in postAvgTemp){
                        if(postTotalPower[k]>0&&me.polyCurb(postAvgTemp[k])>0){
                            totalPowerSum+=postTotalPower[k];
                            totalSavingSum=totalSavingSum+me.polyCurb(postAvgTemp[k])-postTotalPower[k]
                        }
                    }
                    me.totalPowerSum=totalPowerSum;
                    me.totalSavingSum=totalSavingSum;
                    me.data = [
                        {
                            x: polyCurbTemp,
                            y: polyCurbPower,
                            name: 'BMS Trend Line',
                            line: {
                                color: 'rgb(31, 119, 180)',
                            },
                        },
                        {
                            x: preAvgTemp,
                            y: preTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"Before optimisation",
                            hovertext:preLabels,
                            marker: {
                                color: 'rgb(31, 119, 180)',
                            }
                        },
                        // {
                        //     x: trendBefore[0],
                        //     y: trendBefore[1],
                        //     type: 'scattergl',
                        //     name:"Before optimisation trend",
                        //     mode: 'lines',
                        //     line: {
                        //         color: 'rgb(31, 119, 180)',
                        //         width: 2,
                        //         dash:'dot'
                        //     }
                        // },
                        {
                            x: postAvgTemp,
                            y: postTotalPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name:"After optimisation",
                            hovertext:postLabels,
                            marker: {
                                color: 'rgb(255, 127, 14)',
                            }
                        }
                    ]
                    me.loading=false;
                });

                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result.filter(x=>!(x.topic==="anomaly"||x.title.toLowerCase().startsWith("anomaly"))&&(x.severity.toLowerCase()==="critical"||x.severity.toLowerCase()==="high"||x.severity.toLowerCase()==="medium"))
                    me.totalFault=rangeFaults.length;
                    me.unackFault=rangeFaults.filter(x=>!x.acknowledged).length;
                    me.ackFault=rangeFaults.filter(x=>!!x.acknowledged).length;
                    rangeFaults=rangeFaults.filter(x=>!x.acknowledged)
                    let faultsByType={
                        'Chillers':rangeFaults.filter(x=>x.equipment_type.toLowerCase().startsWith('chiller')).length,
                        'Pumps':rangeFaults.filter(x=>x.equipment_type.toLowerCase().endsWith('water_pump')).length,
                        'VAVs':rangeFaults.filter(x=>x.equipment_type==="VAV").length,
                    }
                    if(me.ahus.length>0){
                        faultsByType['AHUs']=rangeFaults.filter(x=>x.equipment_type==="ECFAN"||x.equipment_type==="AHU").length
                    } else if(me.paus.length>0){
                        faultsByType['PAUs']=rangeFaults.filter(x=>x.equipment_type==="PAU").length
                    }
                    if(me.$store.state.pointsListStore.pointsList.facility_name==="CH"){
                        faultsByType['Cooling Towers']=rangeFaults.filter(x=>x.equipment_type==="COOLING_TOWER").length
                    }
                    let sorted = Object.keys(faultsByType).sort(function(a,b){return faultsByType[a]-faultsByType[b]})
                    let topFDD=[]
                    for(let item of sorted){
                        topFDD.push(faultsByType[item])
                    }
                    me.fddData=[{
                        type: 'bar',
                        x: topFDD,
                        y: sorted,
                        orientation: 'h',
                        marker: {
                            color: 'rgba(214, 39, 40,0.5)',
                            line: {
                                color: 'rgba(214, 39, 40,0.5)',
                                width: 2
                            }
                        },

                    }]


                })
                getIssueSummary({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': null,
                    'date_range': {start:currentRange[0],end:currentRange[1]}
                }).then(function(issues){
                    me.fddCost=issues.summary.reduce(function (acc, obj) { return acc + obj.cost; }, 0)
                })
                let allSensors=0
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    allSensors+=this.$store.state.pointsListStore.pointsList.sensors[i].length
                }
                me.totalSensors=allSensors;
                getRule({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                }).then(function(rulerez){
                   me.totalRules=rulerez.result.length
                })
            }

        },
        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.baseDate=moment(preconf.rangeStart)
                this.endDate=moment(preconf.rangeEnd)
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
            } else if(maxDate){
                this.baseDate=moment(maxDate).subtract(8, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
<style>
    .gaugepos1{
        position: absolute;
        top: 130px;
        left: 160px;
        font-size: x-large;
    }
    .gaugepos1percent{
        position: absolute;
        top: 130px;
        left: 200px;
        font-size: x-large;
    }
    .hidden{
        display: none !important;
    }
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
    .green-icon .theme--dark.v-icon{
        color: #77C16B;
    }
    .green-thing{
        color: #77C16B;
    }
</style>
